/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MovimentoTrattamentoUpdateDTO
 */
export interface MovimentoTrattamentoUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoUpdateDTO
     */
    quantita?: number;
    /**
     * 
     * @type {string}
     * @memberof MovimentoTrattamentoUpdateDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoUpdateDTO
     */
    valoreFixed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoUpdateDTO
     */
    idCapannone?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoUpdateDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoUpdateDTO
     */
    idTipoTrattamento?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoUpdateDTO
     */
    idTecnico?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoUpdateDTO
     */
    valore?: number;
    /**
     * 
     * @type {Date}
     * @memberof MovimentoTrattamentoUpdateDTO
     */
    dataInizio?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MovimentoTrattamentoUpdateDTO
     */
    dataFine?: Date;
}

/**
 * Check if a given object implements the MovimentoTrattamentoUpdateDTO interface.
 */
export function instanceOfMovimentoTrattamentoUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MovimentoTrattamentoUpdateDTOFromJSON(json: any): MovimentoTrattamentoUpdateDTO {
    return MovimentoTrattamentoUpdateDTOFromJSONTyped(json, false);
}

export function MovimentoTrattamentoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MovimentoTrattamentoUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantita': !exists(json, 'quantita') ? undefined : json['quantita'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'valoreFixed': !exists(json, 'valoreFixed') ? undefined : json['valoreFixed'],
        'idCapannone': !exists(json, 'idCapannone') ? undefined : json['idCapannone'],
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'idTipoTrattamento': !exists(json, 'idTipoTrattamento') ? undefined : json['idTipoTrattamento'],
        'idTecnico': !exists(json, 'idTecnico') ? undefined : json['idTecnico'],
        'valore': !exists(json, 'valore') ? undefined : json['valore'],
        'dataInizio': !exists(json, 'dataInizio') ? undefined : (new Date(json['dataInizio'])),
        'dataFine': !exists(json, 'dataFine') ? undefined : (new Date(json['dataFine'])),
    };
}

export function MovimentoTrattamentoUpdateDTOToJSON(value?: MovimentoTrattamentoUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantita': value.quantita,
        'note': value.note,
        'valoreFixed': value.valoreFixed,
        'idCapannone': value.idCapannone,
        'idTipoAnimale': value.idTipoAnimale,
        'idTipoTrattamento': value.idTipoTrattamento,
        'idTecnico': value.idTecnico,
        'valore': value.valore,
        'dataInizio': value.dataInizio === undefined ? undefined : (value.dataInizio.toISOString()),
        'dataFine': value.dataFine === undefined ? undefined : (value.dataFine.toISOString()),
    };
}

